import { render, staticRenderFns } from "./categorylist.vue?vue&type=template&id=5ef440ca&"
import script from "./categorylist.vue?vue&type=script&lang=js&"
export * from "./categorylist.vue?vue&type=script&lang=js&"
import style0 from "./categorylist.vue?vue&type=style&index=0&id=5ef440ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports